import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SessionStorageHelper {

  saveObjectToSessionStorage(key: string, value: any) {
    const valueAsJson = JSON.stringify(value);
    sessionStorage.setItem(key, valueAsJson);
  }

  retrieveObjectFromSessionStorage<T>(key: string) {
    const jsonValue = sessionStorage.getItem(key);
    const parsedValue = JSON.parse(jsonValue!);
    return parsedValue as T;
  }

}
